var Dropdown = require('./dropdown');
var AccountCollection = require('../collections/account');

var AccountDropdown = Dropdown.extend({
  template: require('../templates/dropdown.html'),

  constructor() {
    this.collection = new AccountCollection();
    Marionette.CompositeView.prototype.constructor.apply(this, arguments);
    this.collection.fetch();
  },

  attribute: 'settlement_account'
});

module.exports = AccountDropdown;



// WEBPACK FOOTER //
// ./transactions/views/account_dropdown.js